/* import __COLOCATED_TEMPLATE__ from './sort-icon.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();